module.exports = __webpack_public_path__ + "img/hr-sand-dune-decal-04.32317d62.png";